import { useState } from "react";
import { Reveal } from "./Reveal";
import { BLOGS } from "../lib/blogs";
import { Dialog, DialogContent } from "./ui/dialog";
import { ArrowUpRight, X, Clock } from "lucide-react";

export const Blog = () => {
  const [active, setActive] = useState(null);
  const post = BLOGS.find((b) => b.slug === active);

  return (
    <section id="journal" className="border-t border-[#262626]" data-testid="journal-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-36">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
          <Reveal className="lg:col-span-8">
            <span className="overline">Journal</span>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-5 text-[#F7F5F2] text-balance">
              Notes on law &amp; justice.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4">
            <p className="text-[#8C8C8C] leading-relaxed">Perspectives from Advocate Manpreet Singh Bhatti on the matters that shape our clients' lives.</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 border-t border-l border-[#262626]">
          {BLOGS.map((b, i) => (
            <Reveal key={b.slug} delay={(i % 2) * 0.1}>
              <button
                onClick={() => setActive(b.slug)}
                data-testid={`blog-card-${b.slug}`}
                className="group w-full text-left border-b border-r border-[#262626] hover:bg-[#121212] transition-colors duration-500 flex flex-col h-full"
              >
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img src={b.cover} alt={b.title} loading="lazy" className="w-full h-full object-cover grayscale-[0.25] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                  <span className="absolute top-4 left-4 font-mono text-[0.65rem] uppercase tracking-widest bg-[#0A0A0A]/80 text-[#C8A24B] px-3 py-1.5 border border-[#262626]">{b.tag}</span>
                </div>
                <div className="p-8 lg:p-10 flex flex-col flex-1">
                  <div className="flex items-center gap-3 font-mono text-xs text-[#8C8C8C] uppercase tracking-wider">
                    <span>{b.date}</span><span>·</span><span className="flex items-center gap-1"><Clock size={12} /> {b.read}</span>
                  </div>
                  <h3 className="font-serif text-2xl lg:text-3xl mt-4 text-[#F7F5F2] group-hover:text-[#C8A24B] transition-colors duration-300">{b.title}</h3>
                  <p className="text-[#8C8C8C] mt-3">{b.subtitle}</p>
                  <span className="mt-auto pt-8 inline-flex items-center gap-2 text-sm text-[#F7F5F2]">
                    Read article <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl w-[94vw] max-h-[90vh] overflow-y-auto bg-[#0A0A0A] border border-[#262626] text-[#F7F5F2] p-0 [&>button]:hidden" data-testid="blog-dialog">
          {post && (
            <article>
              <div className="relative aspect-[21/9] overflow-hidden">
                <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
                <button onClick={() => setActive(null)} data-testid="blog-dialog-close" className="absolute top-4 right-4 h-10 w-10 grid place-items-center rounded-full bg-[#0A0A0A]/70 border border-[#262626] text-[#F7F5F2] hover:bg-[#C8A24B] hover:text-[#0A0A0A] transition-colors">
                  <X size={18} />
                </button>
              </div>
              <div className="p-8 lg:p-12">
                <div className="flex items-center gap-3 font-mono text-xs text-[#C8A24B] uppercase tracking-wider">
                  <span>{post.tag}</span><span className="text-[#8C8C8C]">·</span><span className="text-[#8C8C8C]">{post.date}</span><span className="text-[#8C8C8C]">·</span><span className="text-[#8C8C8C]">{post.read}</span>
                </div>
                <h2 className="font-serif font-light text-3xl lg:text-5xl leading-tight mt-5">{post.title}</h2>
                <p className="text-[#8C8C8C] text-lg mt-3 font-serif italic">{post.subtitle}</p>
                <p className="font-mono text-xs text-[#8C8C8C] mt-4 uppercase tracking-wider">By {post.author}</p>
                <div className="mt-8 space-y-5 border-t border-[#262626] pt-8">
                  {post.content.map((block, idx) =>
                    typeof block === "string" ? (
                      <p key={idx} className="text-[#c9c7c3] leading-[1.9]">{block}</p>
                    ) : (
                      <h3 key={idx} className="font-serif text-2xl text-[#F7F5F2] pt-3">{block.h}</h3>
                    )
                  )}
                </div>
              </div>
            </article>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
